import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-109c2f42"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "open sm-account" };
import { useMessage } from '@/const/messages';
import Button from '@/materials/atoms/Button.vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { format, ORDER } = useMessage();
        const openAccount = () => {
            window.open('https://www.bigboss-financial.com/account/qopen', '_blank');
        };
        const showConfirm = () => {
            location.href = '/members/sign_in';
            return;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Button, {
                    width: "170px",
                    height: "50px",
                    class: "button pd open_account overlay_z",
                    "inner-text": _unref(format)(_unref(ORDER).OPEN_ACCOUNT),
                    "color-mode": 'login',
                    onClick: openAccount
                }, null, 8, ["inner-text"]),
                _createVNode(Button, {
                    width: "170px",
                    height: "50px",
                    class: "button overlay_z",
                    "inner-text": _unref(format)(_unref(ORDER).LOGIN),
                    "color-mode": 'login',
                    onClick: showConfirm
                }, null, 8, ["inner-text"])
            ]));
        };
    }
});
